export const checkPhoneNumberLeadingCharacters = (
  phoneNumber: string,
): string => {
  if (!phoneNumber) return phoneNumber;

  let newNumber = phoneNumber;

  // remove leading +
  while (newNumber.startsWith('++')) {
    newNumber = newNumber.slice(1);
  }

  // remove leading zeroes
  if (newNumber.startsWith('000')) {
    while (newNumber[1] === '0') {
      newNumber = newNumber.slice(1);
    }
  }

  // remove zeroes following +
  while (newNumber.startsWith('+0')) {
    const plus = newNumber.slice(0, 1);
    const numbersAfterZero = newNumber.slice(2);
    newNumber = `${plus}${numbersAfterZero}`;
  }

  return newNumber;
};
